import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In iOS, PostHog uses method swizzling on `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/foundation/urlsession"
      }}>{`URLSession`}</a>{` methods, which allows for the out-of-the-box collection of network data.`}</p>
    <p>{`However, URLSession’s async/await-powered APIs which are not exposed to the `}<inlineCode parentName="p">{`objc`}</inlineCode>{` runtime and cannot be swizzled. As a result, network telemetry cannot be automatically captured. `}</p>
    <p>{`For apps using async `}<inlineCode parentName="p">{`URLSession`}</inlineCode>{` methods, PostHog provides wrapper functions that you can use to manually capture network logs. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import PostHog

func fetchData(from url: URL) async throws -> Data {
   // let (data, _) = try await URLSession.shared.data(from: url)      // ⬅ replace this
   let (data, _) = try await URLSession.shared.postHogData(from: url)  // 🦔 with this

  // your logic here...
  return data
    
}
`}</code></pre>
    <p>{`You can find a list of available methods to use manually in the `}<a parentName="p" {...{
        "href": "https://github.com/PostHog/posthog-ios/blob/main/PostHog/Replay/URLSessionExtension.swift"
      }}>{`URLSession extension source`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Only metric-like data like speed, size, and response code are captured. No data is captured from the request or response body.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      